var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33315 6.9147L10.0083 0.239632C10.1627 0.0851213 10.3688 0 10.5886 0C10.8083 0 11.0144 0.0851213 11.1688 0.239632L11.6604 0.731092C11.9803 1.05133 11.9803 1.57182 11.6604 1.89157L6.05508 7.49689L11.6666 13.1084C11.821 13.2629 11.9062 13.4689 11.9062 13.6885C11.9062 13.9084 11.821 14.1144 11.6666 14.269L11.175 14.7604C11.0205 14.9149 10.8146 15 10.5948 15C10.375 15 10.1689 14.9149 10.0146 14.7604L3.33315 8.0792C3.1784 7.9242 3.0934 7.71725 3.09388 7.49726C3.0934 7.2764 3.1784 7.06958 3.33315 6.9147Z",
    fill: "#A0A3B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrow);
export default __webpack_public_path__ + "static/media/shortArrow.cc1768af00c6930d3a6a8c69787e0ba0.svg";
export { ForwardRef as ReactComponent };